import styles from './index.module.scss';

export const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <span>Powered by</span>
        <a href="https://github.com/breezedeus/Pix2Text" target="_blank" rel="noopener noreferrer">Pix2Text (P2T)</a>
        <span>and</span>
        <a href="https://www.breezedeus.com/" target="_blank" rel="noopener noreferrer">Breezedeus</a>
      </div>
    </footer>
  );
};
